// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"7b5c9623","341":"d04918e4","438":"e2c8903a","706":"1ef6070e","726":"ed20a8c7","949":"98f15d30"}[chunkId] + ".chunk.js";
};